import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../actions/actionCreators"
import Dashboard from "../component/dashboard.js";
import moment from 'moment';

import 'moment/locale/fr';
moment.locale('fr');

class Dashboardcon extends React.Component{

  state = {
    lineChartData : [],
    pieChartData : [],
    invoicesTotal: null,
  }

  componentWillMount()
  {
      /* import les audits */
      this.props.getAuditsAction().then(res => {
        this.lineChartegenerator()
        this.pieChartegenerator()
      })

      /* import les factures */
      this.props.getInvoicesAction().then(res => {
          const startOfMonth = moment().startOf('day').startOf('month').format('YYYY-MM-DD HH:mm');
          const endOfMonth   = moment().endOf('day').endOf('month').format('YYYY-MM-DD HH:mm');
          const invoicesThisMonth = res.filter(invoice => (moment(invoice.date).isSameOrAfter(startOfMonth) && moment(invoice.date).isSameOrBefore(endOfMonth)))
          var total = 0;
          for (var i = 0; i < invoicesThisMonth.length; i++){
              var audits = invoicesThisMonth[i].audits;
              var ht = 0;
              for (var j = 0; j < audits.length; j++){
                  ht += audits[j].type.price;
              }
              total += (ht + (ht * this.props.user.tva_percent/100))
          }
          this.setState({invoicesTotal: total})
      })
  }

  pieChartegenerator()
  {
    let data = [
      {name:"En attente", value: 0},
      {name:"Rendez-vous validé", value: 0},
      {name:"Validé", value: 0},
      {name:"Écart", value: 0},
      {name:"Rejeté", value: 0}
    ]

    for (var i = 0; i < this.props.audits.length; i++) {
      let audit = this.props.audits[i]

      switch(audit.status) {
        case 'waiting':
          data[0].value ++
        break;
        case 'appointment':
          data[1].value ++
        break;
        case 'valid':
          data[2].value ++
        break;
        case 'issue':
          data[3].value ++
        break;
        case 'reject':
          data[4].value ++
        break;
        default:
        break;
      }
    }

    /* Retire les objets vide du piechart */
    var k = data.length
    while (k--) {
      if (data[k].value === 0) {
        data.splice(k, 1)
      }
    }

    this.setState({
      pieChartData: data
    })
  }

  lineChartegenerator()
  {
    let months = []

    // Rempli le tableau months avec les 6 derniers modifiés
    let currentmonth = moment()
    for (var h = 0; h < 6; h++) {
      months.unshift({name:currentmonth.format('MMMM YYYY'), ajouté:0, modifié:0})
        currentmonth.subtract(1, 'month')
    }

    for (var i = 0; i < this.props.audits.length; i++) {
      let audit = this.props.audits[i]
      let audit_added_date = moment(audit.created)
      let audit_updated_date = moment(audit.updated)

      for (var j in months) {
        if (months[j].name === audit_added_date.format('MMMM YYYY')) {
          months[j].ajouté ++
        }
        if (months[j].name === audit_updated_date.format('MMMM YYYY')) {
          months[j].modifié ++
        }
      }

    }
    this.setState({
      lineChartData: months
    })
  }

    getEventColor(audit){
      switch(audit.status){
          case "waiting":
              return "rgb(76, 165, 195)";
          case "appointment_notified":
              return "rgb(255, 197, 0)";
          case "appointment":
              return "rgb(172, 149, 220)";
          case "issue":
              return "rgb(195, 195, 76)";
          case "reject":
              return "#e74c3c";
          case "valid":
              return "#38a84c";
          default:
              return "rgb(76, 165, 195)";
      }
    }

  render()
  {
    return(
      <Dashboard
        history={this.props.history}
        events={[...this.props.archives, ...this.props.audits].map(audit => {
          return {
            id: audit.id,
            title: audit.company ? audit.company.name : "",
            start: moment(audit.date).toDate(),
            end: moment(audit.date).add(1, "hour").toDate(),
            color:this.getEventColor(audit),
          }
        })}
        invoicesTotal={this.state.invoicesTotal}
        audits={this.props.audits ? this.props.audits : []}
        displaySnackbar={this.props.displaySnackbar}
        closeSnackbar={this.props.closeSnackbar}
        lineChartData={this.state.lineChartData}
        pieChartData={this.state.pieChartData}
      ></Dashboard>
    )
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Dashboardcon);



// WEBPACK FOOTER //
// ./src/container/dashboard-container.js